import { AxiosResponse } from "axios";

import API from "../api";

import { Options } from "../models/access";

const AccessService = {
  async getAllDrivewayLengths(options?: any): Promise<AxiosResponse<Options[]>> {
    return await API.get(`driveways/lengths`, { params: options });
  },
  async getAllActions(options?: any): Promise<AxiosResponse<Options[]>> {
    return await API.get(`actions`, { params: options });
  },
  async getAllParkings(options?: any): Promise<AxiosResponse<Options[]>> {
    return await API.get(`parkings`, { params: options });
  },
  async getAllCarryDistances(options?: any): Promise<AxiosResponse<Options[]>> {
    return await API.get(`carry/distances`, { params: options });
  },
  async getAllDriveways(options?: any): Promise<AxiosResponse<Options[]>> {
    return await API.get(`driveways`, { params: options });
  },
};

export default AccessService;
